document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');

  if (!button || !menu) return;

  const setMenuState = (isOpen) => {
    button.setAttribute('aria-expanded', String(isOpen));
    button.setAttribute(
      'aria-label',
      isOpen ? 'Uždaryti meniu' : 'Atidaryti meniu'
    );

    menu.hidden = !isOpen;

    document.body.classList.toggle('menu-open', isOpen);
  };

  button.addEventListener('click', () => {
    const isOpen =
      button.getAttribute('aria-expanded') === 'true';

    setMenuState(!isOpen);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const isOpen =
      button.getAttribute('aria-expanded') === 'true';

    if (!isOpen) return;

    setMenuState(false);
    button.focus();
  });
});